import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/deep-dive/page.tsx");
